import { PackageIcon } from '@phosphor-icons/react'

import * as Styles from './styles'

const CodeText = ({ code, variant }) => {
  return (
    <Styles.CodeText variant={variant} type={['proposed', 'match'].includes(variant) ? 'bodyMBold' : 'bodyMRegular'}>
      <PackageIcon />
      {code}
    </Styles.CodeText>
  )
}

export default CodeText
